import React, { useState, useEffect } from 'react'
import { Panel, Message, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import ProjectClosedLateForm from './ProjectClosedLateForm'
import ProjectClosedLateTable from './ProjectClosedLateTable'
import ProjectTrackingNoteWidget from './ProjectTrackingNoteWidget'
import {
  getManageProjectClosedLate,
  getManageProjectTracking,
} from '../../../redux/actions/adminManageProjectClosedLate'

export default function ProjectClosedLateWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(props.schema.form)
  const [errorMsg, setErrorMsg] = useState()
  const [dataTable, setDataTable] = useState(props.schema.searchResult || [])
  const [dataTracking, setDataTracking] = useState()
  const [expandedSearch, setExpandedSearch] = useState(true)
  const [onClear, setOnClear] = useState(false)
  const [rowData, setRowData] = useState()

  const onSubmit = (data) => {
    console.log('onSubmit', data)
    const request = {
      projectCode: data.projectCode || null,
      projectName: data.projectName || null,
      pageNumber: 1,
      pageSize: 5,
    }

    handleGetSchema(request)
  }

  const handelGetSchemaOnReload = async (pagesize, pagenumber) => {
    console.log('handelGetSchemaOnReload ', pagesize, pagenumber)

    const request = {
      projectCode: null,
      projectName: null,
      pageNumber: pagenumber,
      pageSize: pagesize,
    }

    handleGetSchema(request)
  }

  const onCancel = async () => {
    console.log('on cancel 333')
    setOnClear(!onClear)
    const request = {
      projectCode: null,
      projectName: null,
      pageNumber: 1,
      pageSize: 5,
    }

    handleGetSchema(request)
  }

  const onSelect = async (data) => {
    console.log('data  => ', data)
    setExpandedSearch(false)
    setRowData(data)
    handleGetSchemaProjectTracking(data.projectId)
    // setDataTracking(projectId)
  }

  const handleGetSchemaProjectTracking = async (projectId) => {
    // setIsLoading(true)
    startLoading()
    try {
      const _schema = await getManageProjectTracking(projectId)

      setDataTracking(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    // setIsLoading(false)
  }

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getManageProjectClosedLate(request)

      setDataTable(_schema.model.searchResult)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleCloseProjectTracking = async () => {
    setExpandedSearch(true)
    onCancel()
  }

  const handleSaveSuccess = (projectId) => {
    handleGetSchemaProjectTracking(projectId)
  }

  const handleSetExpandedSearch = () => {
    setExpandedSearch(true)
    onCancel()
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.searchObject.header}
        collapsible
        defaultExpanded
        expanded={expandedSearch}
        ref={(section) => {
          setSection(section)
        }}
        onSelect={() => {
          handleSetExpandedSearch()
        }}
      >
        <>
          <ProjectClosedLateForm
            schema={formSchema.searchObject}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            handelPreview={onSubmit}
            onClear={onClear}
          />

          {/* <hr /> */}

          {errorMsg && (
            <Message
              showIcon
              type={errorMsg.type}
              description={errorMsg.description}
              style={{ marginBottom: 20 }}
            />
          )}

          <ButtonPanelWidget
            isEdit={true}
            isError={isError}
            buttonText={formSchema.searchObject.buttonText}
            onSave={handleSubmit(onSubmit)}
            onCancel={handleSubmit(onCancel)}
          />

          {dataTable && (
            <ProjectClosedLateTable
              schema={dataTable}
              Controller={Controller}
              control={control}
              pagination={true}
              loading={isLoading}
              onReload={handelGetSchemaOnReload}
              onSelect={onSelect}
            />
          )}
        </>
      </Panel>

      {dataTracking && !expandedSearch && (
        <ProjectTrackingNoteWidget
          schema={dataTracking}
          onClose={handleCloseProjectTracking}
          rowData={rowData}
          onSaveSuccess={handleSaveSuccess}
        />
      )}

      <br />
    </>
  )
}

const mockSchemaSearch = {
  totalSize: 3,
  values: [
    {
      projectId: '',
      budgetYear: '2564',
      department: 'สำนัก 1',
      projectCode: 'XX-1234',
      projectName: 'ทดสอบ 1234',
      coordinator: 'นายศรีสุวรรณ ควรขจร',
      projectStartDate: '2021-01-03',
      projectEndDate: '2021-12-03',
      dayOfDelay: 20,
      projectStatus: 'กลั่นกรอง',
    },
    {
      projectId: '',
      budgetYear: '2564',
      department: 'สำนัก 1',
      projectCode: 'XX-12345',
      projectName: 'ทดสอบ 12345',
      coordinator: 'นายศรีสุวรรณ ควรขจร',
      projectStartDate: '2021-01-03',
      projectEndDate: '2021-12-03',
      dayOfDelay: 20,
      projectStatus: 'กลั่นกรอง',
    },
    {
      projectId: '',
      budgetYear: '2564',
      department: 'สำนัก 1',
      projectCode: 'XX-123456',
      projectName: 'ทดสอบ 123456',
      coordinator: 'นายศรีสุวรรณ ควรขจร',
      projectStartDate: '2021-01-03',
      projectEndDate: '2021-12-03',
      dayOfDelay: 20,
      projectStatus: 'กลั่นกรอง',
    },
  ],
}

const mockSchemaProjectTracking = {
  header: 'บันทึกติดตามโครงการล่าช้า',
  form: {
    buttonText: {
      disabled: true,
      saveButtonName: 'บันทึก',
      cancelButtonName: 'ยกเลิก',
    },
    note: {
      name: 'inputNote',
      label: 'รายละเดียดการติดตาม',
      value: '',
      hint: 'ระบุรายละเดียดการติดตาม',
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก รายละเดียดการติดตาม',
        },
      ],
    },
    date: {
      name: 'inputDate',
      label: 'วันที่',
      value: null,
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก วันที่',
        },
      ],
    },
    notiStatus: {
      label: 'การแจ้งเตือน : ',
      name: 'notiStatus',
      value: '',
      disabled: true,
      defaultValue: [],
      options: [
        {
          label: 'โทรศัพท์ติดตาม',
          value: 'โทรศัพท์ติดตาม',
        },
        {
          label: 'ออกหนังสือแจ้งเตือน',
          value: 'ออกหนังสือแจ้งเตือน',
        },
        {
          label: 'ออกหนังสือตามงาน',
          value: 'ออกหนังสือตามงาน',
        },
      ],
      validators: [
        {
          type: 'REQUIRED',
          value: null,
          errorMessage: 'กรุณากรอก การแจ้งเตือน',
        },
      ],
    },
  },
  attachFiles: {
    name: 'attachFiles',
    header: 'แนบไฟล์ประกอบการติดตาม',
    buttonText: 'ไฟล์ประกอบการติดตาม',
    fileSize: 50,
    fileType: '.jpg, .jpeg, .png, .pdf',
    description: ['แนบไฟล์ประกอบการติดตาม เกี่ยวกับการแจ้งเตือนการติดตาม'],
    value: [],
    id: null,
  },
  values: [],
}
